import api from './api.service';

export interface Warehouse {
  id: string;
  warehouse_code: string;
  warehouse_name: string;
  warehouse_type?: string;
  /** When set, warehouse is a project WIP / site store */
  project_id?: string | null;
  /** Per-warehouse inventory GL for stock transfer JVs */
  inventory_account_id?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  warehouse_manager_id?: string | null;
  phone?: string | null;
  email?: string | null;
  is_main_warehouse?: boolean;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CreateWarehouseInput {
  warehouse_code: string;
  warehouse_name: string;
  warehouse_type?: string;
  project_id?: string | null;
  inventory_account_id?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  warehouse_manager_id?: string | null;
  phone?: string | null;
  email?: string | null;
  is_main_warehouse?: boolean;
  is_active?: boolean;
}

export type UpdateWarehouseInput = Partial<CreateWarehouseInput>;

class WarehouseService {
  private baseURL = '/inventory/warehouses';

  async getAll(): Promise<Warehouse[]> {
    const response = await api.get(this.baseURL);
    const data = (response as { data?: { data?: Warehouse[] } })?.data?.data ?? (response as { data?: Warehouse[] })?.data;
    return Array.isArray(data) ? data : [];
  }

  async getById(id: string): Promise<Warehouse> {
    const response = await api.get(`${this.baseURL}/${id}`);
    const data = (response as { data?: { data?: Warehouse } })?.data?.data ?? (response as { data?: Warehouse })?.data;
    if (!data) throw new Error('Warehouse not found');
    return data;
  }

  async create(data: CreateWarehouseInput): Promise<Warehouse> {
    const response = await api.post(this.baseURL, data);
    const created = (response as { data?: { data?: Warehouse } })?.data?.data ?? (response as { data?: Warehouse })?.data;
    if (!created) throw new Error('Failed to create warehouse');
    return created;
  }

  async update(id: string, data: UpdateWarehouseInput): Promise<Warehouse> {
    const response = await api.put(`${this.baseURL}/${id}`, data);
    const updated = (response as { data?: { data?: Warehouse } })?.data?.data ?? (response as { data?: Warehouse })?.data;
    if (!updated) throw new Error('Failed to update warehouse');
    return updated;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`${this.baseURL}/${id}`);
  }
}

const warehouseService = new WarehouseService();
export default warehouseService;
